import { useContext } from "react";
import styled, { css } from "styled-components";
import ReactHtmlParser from "react-html-parser";
import { TimeContext, EventContext, AnalyticsContext } from "context";
import { MaxWidthContainer } from "./MaxWidthContainer";
import { useMediaQuery } from "hooks";

export const Footer = ({
  showFooter,
  registration,
  registered,
  className,
  voting,
  postCampaign,
  preCampaign,
}) => {
  const { event } = useContext(EventContext);
  const { logClick } = useContext(AnalyticsContext);

  const api = process.env.REACT_APP_FIRE_BASE_STORAGE_API;
  const storageDirectory = event.meta.storageDirectory;
  // brand cta background
  const {
    desktop: brandBgD,
    mobile: brandBgM,
  } = event.callToActions.brand.background;
  let brandBgDesktop = `${api}/${storageDirectory}/${brandBgD}?alt=media`;
  let brandBgMobile = `${api}/${storageDirectory}/${brandBgM}?alt=media`;

  const isMobile = useMediaQuery();
  const {
    // brand: brandLogo,
    // event: eventLogo,
    secondary: secondaryLogo,
  } = event.logos;

  const footerMenu = false;
  const showLogo = true;

  const {
    maxPolicy,
    uscPolicy,
    brandDisclaimer,
    sweepsDisclaimer,
    grandPrizeDisclaimer,
  } = event.footer;

  const logoClickHandler = (link) => {
    logClick({
      label: "Footer Logo",
      url: link,
    });
  };

  const linkClickHandler = (url, label, category) => {
    logClick({ label, url }, category);
  };

  return (
    <>
      {showFooter && (
        <FooterWrapper as="footer" className={className} id="footer">
          <FooterContainer isMobile={isMobile} variant={!!preCampaign}>
            {preCampaign
              ? maxPolicy &&
                uscPolicy && (
                  <>
                    <MaxPolicy
                      aria-label="UScellular privacy policy link opens in a new window"
                      onClick={() =>
                        linkClickHandler(
                          "https://www.uscellular.com/privacy",
                          "UScellular Privacy Policy",
                          "footer"
                        )
                      }
                    >
                      {ReactHtmlParser(uscPolicy)}
                    </MaxPolicy>
                    <MaxPolicy
                      aria-label="MAX privacy policy link opens in a new window"
                      onClick={() =>
                        linkClickHandler(
                          "https://www.max.live/privacy-policy",
                          "MAX privacy policy",
                          "footer"
                        )
                      }
                    >
                      {ReactHtmlParser(maxPolicy)}
                    </MaxPolicy>
                    <MaxPolicy>
                      <CookieButton
                        aria-label="button to open set Cookie preferences"
                        variant={!!preCampaign}
                        onClick={() => {
                          if (window.Cookiebot) {
                            window.Cookiebot.renew();
                          }
                        }}
                      >
                        Click here to set Cookie Preferences
                      </CookieButton>
                    </MaxPolicy>
                  </>
                )
              : brandDisclaimer && (
                  <BrandDisclaimer
                    tabIndex={0}
                    aria-label="Official Sweepstakes Rules link opens in a new window"
                    onClick={() =>
                      linkClickHandler(
                        "Rules",
                        "Footer Rules/privacy policy",
                        "footer"
                      )
                    }
                  >
                    {ReactHtmlParser(brandDisclaimer)} &nbsp;
                    <br />
                    <br />
                    <CookieButton
                      aria-label="button to open set Cookie preferences"
                      variant={!!preCampaign}
                      onClick={() => {
                        if (window.Cookiebot) {
                          window.Cookiebot.renew();
                        }
                      }}
                    >
                      Click here to set Cookie Preferences
                    </CookieButton>
                  </BrandDisclaimer>
                )}
          </FooterContainer>
        </FooterWrapper>
      )}
    </>
  );
};

const FooterWrapper = styled.footer`
  display: flex;
  flex-direction: row;
  font-size: 13px;
  z-index: 1;
  position: relative;

  @media ${(props) => props.theme.maxMedia.medium} {
    width: 100%;
    max-width: 1700px;
    margin: -5px auto 0 auto;
    position: relative;
  }
`;

const FooterContainer = styled(MaxWidthContainer)`
  display: flex;
  flex-direction: row;
  justify-content: center;
  flex: 1;
  padding: 35px 150px 35px 95px;
  background-color: #fff;
  color: #000;
  z-index: 10;
  gap: 30px;
  a {
    color: #000;
  }
  ${(props) =>
    props.isMobile &&
    css`
      flex-direction: column;
      gap: 0px;
      padding: 30px;
      align-items: center;
    `}
  ${(props) =>
    props.variant &&
    css`
      background-color: #0731a1;
      color: #fff;
      a {
        color: #fff !important;
      }
    `}
`;
const CookieButton = styled.button`
  border: none;
  background-color: transparent;
  display: inline;
  font-size: 13px;
  font-weight: 300;
  cursor: pointer;
  color: #322ffd;
  text-decoration: none;
  font-family: "BrandonBld";
  padding: 0;
  ${(props) =>
    props.variant &&
    css`
      text-decoration: underline;
      font-family: "BrandonReg";
      color: #fff !important;
    `}
`;

const MaxPolicy = styled.p`
  margin-top: 0;
`;

const BrandDisclaimer = styled.div`
  margin-bottom: 20px;

  a,
  a :visited {
    color: #322ffd;
    text-decoration: none;
    font-family: "BrandonBld";
  }
`;
